import { SelectTypes } from '@genial/components';
import { Color } from '@genial/design-tokens';

import { FundraisingAssetEvolutionPeriodOptions } from '../../../../../../store/home/capture/types';

export const periodOptionsLabels: Record<FundraisingAssetEvolutionPeriodOptions, string> = {
  Last7Days: 'Últimos 7 dias',
  Last15Days: 'Últimos 15 dias',
  Last30Days: 'Últimos 30 dias',
};

export const periodOptions: SelectTypes.Option[] = Object.entries(periodOptionsLabels).map(
  ([key, value]) => ({
    label: value,
    value: key,
  })
);

export const defaultPeriodOption: FundraisingAssetEvolutionPeriodOptions = 'Last7Days';

export const chartValues = {
  assetNetValue: {
    name: 'PATRIMÔNIO',
    color: Color['brand.tertiary.light'],
    dataKey: 'assetNetValue',
  },
};

export const chartNameMap = new Map(
  Object.values(chartValues).map((value) => [value.dataKey, value.name])
);
